import { useEffect, useState } from 'react';
import numeral from 'numeral';
import querySearch from 'stringquery';

const formatNumber = (number) => {
    let result = number;
    if (number) {
        result = numeral(number).format('0,0');
    }
    return result;
}

const parseQueryParams = (props) => {
    if (props && props.location) {
        const parsed = querySearch(props.location.search);
        return parsed;
    } else {
        return null;
    }
}

// Hook
const useDebounce = (value, delay) => {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(
      () => {
        // Update debounced value after delay
        const handler = setTimeout(() => {
          setDebouncedValue(value);
        }, delay);
  
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return () => {
          clearTimeout(handler);
        };
      },
      [value, delay] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
  }

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    formatNumber,
    parseQueryParams,
    useDebounce,
}